import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Index } from './pages/Index.tsx';
import { About } from './pages/About.tsx';
import { Contact } from './pages/Contact.tsx';
import { Facilities } from './pages/Facilities.tsx';
import { History } from './pages/History.tsx';
import { Location } from './pages/Location.tsx';
import { Events } from './pages/Events.tsx';
import { Activities } from './pages/Activities.tsx';
import { Rules } from './pages/Rules.tsx';
import { Shop } from './pages/Shop.tsx';
import { MoreInfo } from './pages/MoreInfo.tsx';
import { Membership } from './pages/Membership.tsx';
import { CivilianMarksmanshipProgram } from './pages/CivilianMarksmanshipProgram.tsx';
import './index.css';

function App() {
  return (
    <HelmetProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/facilities" element={<Facilities />} />
          <Route path="/history" element={<History />} />
          <Route path="/location" element={<Location />} />
          <Route path="/events" element={<Events />} />
          <Route path="/activities" element={<Activities />} />
          <Route path="/rules" element={<Rules />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/more-info" element={<MoreInfo />} />
          <Route path="/membership" element={<Membership />} />
          <Route path="/cmp" element={<CivilianMarksmanshipProgram />} />
        </Routes>
      </Router>
    </HelmetProvider>
  );
}

export default App;
